module.exports = __webpack_public_path__ + "img/face-pensive.333373cb.svg";